/**
 * Whether a view can be called this, or why not. Names are unique per page, including
 * the shipped default's - the service only sees the stored rows.
 */
export function validateViewName(name: string, otherNames: string[]) {
  const trimmed = (name || "").trim();

  if (!trimmed) {
    return "A view needs a name";
  }

  const taken = otherNames.some(
    (other) => (other || "").trim().toLowerCase() === trimmed.toLowerCase()
  );

  return taken ? `Another view is already called "${trimmed}"` : null;
}
